import { useMemo } from "react";

import { type LensDestination, type MyLensesLensStatus } from "../../gql-generated/types";
import { makeDisplayStatus } from "../state";

export const useLensStatus = (
    status: MyLensesLensStatus,
    destinations: readonly LensDestination[] = [],
): { name: string; color: string } => {
    return useMemo(() => makeDisplayStatus(status, destinations), [status, destinations]);
};
